<div class="celebration-backdrop" (click)="close()">
    <div class="celebration-card" (click)="$event.stopPropagation()">
        <ion-icon name="sparkles" class="celebration-sparkle"></ion-icon>

        <p class="celebration-rating" data-testid="celebration-rating" *ngIf="match && result.ratingDelta != null">Rating {{ result.rating }} ({{ result.ratingDelta > 0 ? '+' : '' }}{{ result.ratingDelta }})</p>

        <div class="celebration-levelup" *ngIf="result.leveledUp">
            <h1>Level {{ result.newLevel }}!</h1>
            <p>Je bent gestegen naar een nieuw level.</p>
        </div>

        <div class="celebration-badges" *ngIf="result.unlockedBadges?.length > 0">
            <h2>Nieuwe badge{{ result.unlockedBadges.length > 1 ? 's' : '' }}!</h2>
            <div class="celebration-badge" data-testid="celebration-badge" *ngFor="let badge of result.unlockedBadges" [attr.data-track]="badge.track">
                <ion-icon [name]="badgeIcon(badge.track)"></ion-icon>
                <span>{{ badgeLabel(badge.track) }}</span>
            </div>
        </div>

        <ion-button data-testid="celebration-share" expand="block" *ngIf="match" (click)="shareRecap()">
            <ion-icon slot="start" name="share-social-outline"></ion-icon>Deel uitslag
        </ion-button>

        <ion-button data-testid="celebration-close" expand="block" fill="clear" (click)="close()">Mooi zo!</ion-button>
    </div>
</div>
